export default "__VITE_ASSET__DrgQbQVw__"